import { ADMIN, CONTROL } from '@rootCommon/constants/common';
import { FHQ_TEMPLATE } from '@rootCommon/constants/end-points';
import CrudRequest from '@rootCommon/services/crud-request';
import { IdType } from '@rootTypes/common';
import { InviteTemplate, InviteTemplatesRequest } from '@rootTypes/fhq-invite-template';

class FhqTemplateService {
  private getSiteFhqTemplates = async (sender: string, siteFhqId: IdType): Promise<InviteTemplate[]> => {
    const res = await CrudRequest.get<InviteTemplate[]>(`${FHQ_TEMPLATE}/all/${sender}`, { params: { siteFhqId } });

    return res.data;
  };

  private getPatientTemplates = async (url: string, params: InviteTemplatesRequest): Promise<InviteTemplate[]> => {
    const res = await CrudRequest.get<InviteTemplate[]>(`${FHQ_TEMPLATE}/all/${url}`, { params });

    return res.data;
  };

  getAdminInviteTemplates = (siteFhqId: IdType) => this.getSiteFhqTemplates(ADMIN, siteFhqId);

  getControlInviteTemplates = (siteFhqId: IdType) => this.getSiteFhqTemplates(CONTROL, siteFhqId);

  getPatientInviteTemplates = (params: InviteTemplatesRequest) => this.getPatientTemplates('invitation', params);

  getPatientReminderTemplates = (params: InviteTemplatesRequest) => this.getPatientTemplates('reminder', params);
}

export default new FhqTemplateService();
